import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/fbpixel';
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className="relative w-full bg-brand-cream overflow-hidden" data-id="element-59">
      <div className="max-w-6xl mx-auto px-6 py-12 md:py-20 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 items-center" data-id="element-60">
        {/* Text */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="order-2 md:order-1" data-id="element-61">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-blue/10 text-brand-blue font-semibold text-sm tracking-wide mb-6 uppercase" data-id="element-62">
            El Protocolo
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-brown leading-tight mb-6" data-id="element-63">
            Sueño para BB en <span className="italic" data-id="element-64">7 Minutos</span>
          </h1>
          <h2 className="text-lg md:text-xl text-brand-textLight leading-relaxed mb-8 font-medium" data-id="element-65">
            Logra que tu bebé se duerma profundamente en menos de 7 minutos con
            la técnica de{' '}
            <strong className="text-brand-brown font-semibold" data-id="element-66">
              Anclaje Sensorial
            </strong>
            , sin dejarlo llorar por horas y recuperando tu derecho a descansar.
          </h2>

          <a href="https://tuvidadigitalmejora.com/cart/51821444038977:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-block text-center w-full sm:w-auto bg-brand-brown hover:bg-brand-brownHover text-white font-semibold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-brand-brown/30" aria-label="Comprar el protocolo" data-id="element-67">
            ¡SÍ, QUIERO QUE MI BEBÉ DUERMA YA!
          </a>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.1
      }} className="order-1 md:order-2" data-id="element-68">
          <div className="rounded-3xl overflow-hidden shadow-soft border border-white" data-id="element-69">
            <img src="https://cdn.magicpatterns.com/uploads/mjKkdhSNo3mnBqM7JAQQSQ/SUENO_8.png" alt="Madre sosteniendo a su bebé llorando en una habitación tranquila" className="w-full h-auto object-cover" data-id="element-70" />
          </div>
        </motion.div>
      </div>
    </header>;
}